<template>
    <div class="v-application font-size-14">
        <div class="w-100 px-2 py-4">
            <div class="text-center mb-5">
                <h1 class="font-size-26" style="text-decoration:underline;">도서거래 명세서</h1>
            </div>

            <v-row align="center">
                <v-col cols="4">
                    <div>
                        <div class="font-size-16 font-weight-bold">{{getToday}}</div>
                        <v-layout align-center>
                            <v-text-field v-model="userName" hide-details placeholder="상호" ></v-text-field>
                            <span> 귀하</span>
                        </v-layout>
                        <div class="mt-2">아래와 같이 명세합니다.</div>
                    </div>
                </v-col>
                <v-col cols="8">
                    <table class="table--border w-100">
                        <colgroup>
                            <col style="width:2%">
                            <col style="width:20%">
                            <col style="width:33%">
                            <col style="width:14%">
                            <col style="width:34%">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th rowspan="5">공<br/>급<br/>자</th>
                                <td class="font-weight-medium">등록번호</td>
                                <td colspan="3">846-81-00822</td>
                            </tr>
                            <tr>
                                <td class="font-weight-medium">상호</td>
                                <td>주식회사 대한문고</td>
                                <td class="font-weight-medium">성명</td>
                                <td>우상덕</td>
                            </tr>
                            <tr>
                                <td class="font-weight-medium">사업장<br class="d-none d-sm-block"/>주소</td>
                                <td colspan="3">서울 강서구 공항대로228, 리더스타워 704, 705호</td>
                            </tr>
                            <tr>
                                <td class="font-weight-medium">업태</td>
                                <td>도소매</td>
                                <td class="font-weight-medium">종목</td>
                                <td>도서 . 문구</td>
                            </tr>
                            <tr>
                                <td class="font-weight-medium">전화번호</td>
                                <td>1800-9510</td>
                                <td class="font-weight-medium">FAX</td>
                                <td>02-6442-9520</td>
                            </tr>
                        </tbody>
                    </table>
                </v-col>
            </v-row>

            <v-divider class="my-4" style="border-color:#ccc!important;" />

            <div class="mb-3">
                <strong class="font-size-18">￦ {{totalPrice.format()}}</strong><span class="font-size-14"> (VAT 포함)</span>
            </div>

            <table class="table--border w-100">
                <colgroup>
                    <col style="width:5%">
                    <col style="width:49%">
                    <col style="width:10%">
                    <col style="width:18%">
                    <col style="width:18%">
                </colgroup>
                <tbody>
                    <tr>
                        <th>No</th>
                        <th>품목</th>
                        <th>수량</th>
                        <th>단가<br/>(VAT 포함)</th>
                        <th>합계</th>
                    </tr>
                    <tr v-for="purchase, index in purchases" :key="index">
                        <td class="text-center">{{index + 1}}</td>
                        <td>{{purchase.product.name}}</td>
                        <td class="text-center">{{purchase.quantity}}</td>
                        <td class="text-right">{{purchase.product.salePrice.format()}}원</td>
                        <td class="text-right">{{(purchase.product.salePrice * purchase.quantity).format()}}원</td>
                    </tr>
                    <tr>
                        <th>계</th>
                        <td colspan="3"></td>
                        <td class="text-right">{{totalPrice.format()}}원</td>
                    </tr>
                </tbody>
            </table>

            <div class="text-center mt-5 d-print-none">
                <v-btn @click="print" color="primary">출력</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api"

export default {
    data(){
        return {
            order: [],
            purchases: [],
            userName: ""
        }
    },
    async mounted(){
        await this.init()
    },
    methods: {
        async init(){
            let { order } = await api.v1.shop.orders.get({ _id: this.$route.params._order })
            this.order.push(order)
            this.purchases = order.purchases
            console.log(order)
        },
        print(){
            if(!this.userName){
                return alert('상호를 입력하세요')
            }
            window.print()
        }
    },
    computed: {
        totalPrice(){
            let totalSum = 0
            this.purchases.map((el)=> {
                totalSum = totalSum + el.product.salePrice *  el.quantity
            })
            return totalSum
        },
        getToday(){
        var date = new Date();
        var year = date.getFullYear();
        var month = ("0" + (1 + date.getMonth())).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);

        return `${year}년 ${month}월 ${day}일`
        }
    }
}
</script>

<style scoped>
.table--border{
    font-size: 14px;
    border:2px solid #222;
}
.table--border tr th, .table--border tr td{
    padding:4px 10px;
    border:1px solid #222;
}
.table--border tr th{
    font-weight:600;
    background-color: #f7f7f7;
}
</style>